module.exports = __webpack_public_path__ + "img/img_vision_03.eaf3c290.png";